import React from 'react'

const ArticoloCard = ({ main_image, data, titolo, href }) => {
  return (
    <div className="articolo">
      <img src={main_image} className="articolo__image" />
      <div className="articolo__content">
        <p className="articolo__content__data">{data}</p>
        <p className="articolo__content__titolo">{titolo}</p>
        <a href={href} target="_blank" className="articolo__content__link">
          Leggi Articolo
        </a>
      </div>
    </div>
  )
}

export default ArticoloCard
